import type { MessengerMessage } from '@/api/client';
import { isMessengerImageMime } from '@/components/Messenger/shared/attachments/messengerImageMime';

/** Вертикальный «bleed» строки треда: компенсация отрицательных margin внутри dm-бабла (см. MessengerDmMessages.css) */
export type DirectDmThreadRowBleed = 'none' | 'grouped' | 'flushImage';

/**
 * Единая точка правды для шага строки лички: родитель (DirectMessageSelectableRow) вешает классы.
 * `stackTightWithPrev` — та же семантика, что `stackWithPrev` у строки (склейка без разделителя / failed).
 */
export function getDirectDmThreadRowBleed(
  msg: MessengerMessage,
  stackTightWithPrev: boolean
): DirectDmThreadRowBleed {
  if (msg.message_kind === 'system') return 'none';
  /** Подряд от одного отправителя — тот же шаг, что в ЛС (без отдельного «flush» на каждом фото). */
  if (stackTightWithPrev) return 'grouped';

  const isDeleted = Boolean(msg.deleted_at);
  const hasImage =
    !isDeleted && Boolean(msg.file_url && isMessengerImageMime(msg.mime_type));
  const hasBody = Boolean(msg.body?.length);
  const hasNonImageFile =
    !isDeleted && Boolean(msg.file_url && !isMessengerImageMime(msg.mime_type));
  const hasCaptionText = !isDeleted && (hasBody || hasNonImageFile);
  const metaInImageCorner = hasImage && !hasCaptionText;
  const splitTailMedia = hasImage && !metaInImageCorner;
  if (hasImage && (splitTailMedia || metaInImageCorner)) return 'flushImage';
  if (stackTightWithPrev) return 'grouped';
  return 'none';
}
